$(function(){
    var lada = Ladda.bind( '.ladda-button');

    if( $('#form-validation').length ) {
        $('#form-validation').validate({
            submit: {
                settings: {
                    inputContainer: '.form-group',
                    errorListClass: 'form-control-error',
                    errorClass: 'has-danger'
                },
                callback: {
                    onInit: function(){
                        Ladda.stopAll();
                    },
                   onError: function(){
                        Ladda.stopAll();
                   },
                },
            },

        });

        $('.form-validation .remove-error').on('click', function(){
            $('.form-validation').removeError();
        });
    }

    if ($('.form-validate').length) {
        $('.form-validate').validate({
            //ignore: [],
            rules: {
                fileupload: {
                    required: true
                },
            },
            errorPlacement: function (error, element) {
                error.addClass("form-control-error");
                element.parent().addClass("has-danger");

                if (element.prop("type") === "checkbox") {
                    error.insertAfter(element.parent("label"));
                } else {
                    error.insertAfter(element);
                }
            },
            success: function (label, element) {
                $(label).remove();
            },
            highlight: function (element, errorClass, validClass) {
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass('is-invalid').parent().removeClass("has-danger");
            },
            invalidHandler: function (form, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    if ($(validator.errorList[0].element).is(":visible")) {
                        $('html, body').animate({
                            scrollTop: $(validator.errorList[0].element).offset().top - 150
                        }, 1000);
                    } else {
                        $('html, body').animate({
                            scrollTop: $("#" + $(validator.errorList[0].element).attr("focusID")).offset().top
                        }, 1000);
                    }
                    Ladda.stopAll();
                }
            },
            submitHandler: function(form) {
                var btn = $(form).find("button[type=submit]");

                if($('select#remap-type').length) {
                    var $selected = $('select#remap-type').find(':selected');
                    var addon_id = $selected.data('addons');
                    var overal_price = filePriceCalculator(addon_id, true);

                    if( $selected.data('price') === 0 && overal_price === 0) {
                        $('html, body').animate({
                            scrollTop: $("select#remap-type").offset().top
                        }, 1000);

                        setTimeout(function() {
                            alert("Please select at least one special request.");
                        }, 1000);
                    } else {
                        btn.attr("disabled", true);
                        btn.find('.btn-text').addClass('hidden');
                        btn.find('.sedox-spinner').removeClass('hidden');
                        form.submit();
                    }
                } else {
                    btn.attr("disabled", true);
                    btn.find('.btn-text').addClass('hidden');
                    btn.find('.sedox-spinner').removeClass('hidden');
                    form.submit();
                }
            }
        });
    }

    if ($('.form-validate-recaptcha').length) {
        if($('#_g-recaptcha').length > 0){
            _beforeSubmit = function() {
                if($('.form-validate-recaptcha').valid()) {
                    return true;
                }
                return false;
            }
        }

        $('.form-validate-recaptcha').validate({
            //ignore: [],
            errorPlacement: function (error, element) {
                error.addClass("form-control-error");
                element.parent().addClass("has-danger");

                if (element.prop("type") === "checkbox") {
                    error.insertAfter(element.parent("label"));
                } else {
                    error.insertAfter(element);
                }
            },
            success: function (label, element) {
                $(label).remove();
            },
            highlight: function (element, errorClass, validClass) {
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass('is-invalid').parent().removeClass("has-danger");
            },

            invalidHandler: function (form, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    if ($(validator.errorList[0].element).is(":visible")) {
                        $('html, body').animate({
                            scrollTop: $(validator.errorList[0].element).offset().top - 150
                        }, 1000);
                    }
                    else {
                        $('html, body').animate({
                            scrollTop: $("#" + $(validator.errorList[0].element).attr("focusID")).offset().top
                        }, 1000);
                    }

                    Ladda.stopAll();
                }
            },
            submitHandler: function(form) {
                var btn = $(form).find("button[type=submit]");

                if($(form).hasClass('ignore')) {
                    return false;
                }

                grecaptcha.ready(function() {
                    grecaptcha.execute('6LdnAcMqAAAAAFLz3CFdVWSFYP35ejXkLBNV9a2I', {action: 'submit'}).then(function(token) {
                        $(form).append("<input type='hidden' name='recaptcha_token' value='" + token + "' />");
                        btn.attr("disabled", true);
                        btn.find('.btn-text').addClass('hidden');
                        btn.find('.sedox-spinner').removeClass('hidden');
                        form.submit();
                    });
                });

            }
        });
    }

    $('input.form-control', this).on('focus', function(e){
        var $this = $(this);
        $this.next('.form-text').removeClass('invisible');
    });

    $('input.form-control', this).on('blur', function(e){
        var $this = $(this);
        $this.next('.form-text').addClass('invisible');
    });

    // TYPING TEASER TEXT
    $('#showcase-type').typed({
        strings: ['Faster requesting of remaps, originals and special modifications.', 'Better overview of uploaded, downloaded files and finances', 'Quicker credit purchase and handling inside the manager', 'Simpler and faster management of sub dealer accounts.'],
        typeSpeed: 30,
        loop: true,
        backDelay: 1000,
		backSpeed: 5,
        cursorChar: ''
    });

    // MENU SCROLLTO
    $('.nav-item a').on('click', function(){
        $('.nav-item a').removeClass('cwt__main-menu__link--active');
        $(this).addClass('cwt__main-menu__link--active');
    });

    $('.cwt__js-click__preview').on('click', function(){
        $.scrollTo($('.cwt__preview'), 1000);
    });

    $('.cwt__js-click__showcase').on('click', function(){
        $.scrollTo($('#howto'), 1000, {offset: -100});
    });

    $('.cwt__js-click__features').on('click', function(){
        $.scrollTo($('#news'), 1000, {offset: -100});
    });

    $('.cwt__js-click__about').on('click', function(){
        $.scrollTo($('.cwt__about'), 1000, {offset: -100});
    });

	$('.cwt__news__teaser a').on('click', function(){
        $.scrollTo($('#news'), 1000, {offset: -100});
    });

    $('#cert-validate').on('click', function() {
        $.ajax({
            type: "post",
            url: "/ajax/certificates/validate",
            data: {"cert_id": $('input#cert').val()},
            beforeSend: function () {},
            error: function (event) {
                Ladda.stopAll();
                if (event.status !== 0) {
                    alert("Invalid server response!");
                }
            },
            success: function (data, textStatus) {
                if (data.result === "error") {
                    data.message = data.message.replace(/\n/g, '');
                    alert(data.message);
                } else {
                    $("#validation-message").html(data.html);
                }
            },
            complete: function () {
                Ladda.stopAll();
            }
        }, "json");
    });
});
